( function ( $ ) {
	$( document ).ready( function () {
		const $megaMenuPrimary = $( '#mega-menu-primary' );
		const $megaMenuLinks = $( 'a.mega-menu-link', $megaMenuPrimary );

		$( 'li.mega-menu-item', $megaMenuPrimary ).on( 'open_panel', function () {
			const $child = $( this ).children( ':first' );

			$megaMenuLinks.each( ( index, item ) => {
				if ( $child[ 0 ] !== item ) {
					try {
						const $item = $( item );
						const $menu = $item.closest( 'ul.max-mega-menu' );

						if ( $menu.data( 'maxmegamenu' ) ) {
							$menu.data( 'maxmegamenu' ).hidePanel( $item, true );
						}
					} catch ( error ) {
						console.error( 'Error closing panel: ', error ); // eslint-disable-line no-console
					}
				}
			} );
		} );
	} );
} )( jQuery );
